import styled from 'styled-components';

export const Content = styled.div`
  .file-name {
    color: ${(props) => props.theme.$dark};
    word-break: break-word;
  }
`;
